<template>
  <div>
    <div class="padding" v-if="$route.query.from == 'mine'">
      <el-page-header :title="$t('返回')" @back="goBack" :content="$t('我的收藏')">
      </el-page-header>
    </div>
    <el-card v-if="$store.state.mode == 'PTE'">
      <h3 slot="header">{{ $t('PTE收藏') }}</h3>
      <el-row :gutter="40">

        <el-col :span="8" :class="{ 'margin-lt': index > 3 }" v-for="index in 5" :key="index">
          <el-card>
            <h3 class="lt pdtb flex flex-between">
              <div><i v-for="index1 in index" style="color:rgb(247, 186, 42)" :key="index1" class="el-icon-star-on"></i>
              </div>
              <div>（{{ (info["pte_" + index] || 0) }}）</div>
            </h3>
            <div class="flex flex-between margin-t flex-y-center">
              <el-link v-if="info['pte_' + index]" type="primary" @click="reset(index)">{{ $t('重置') }}<i
                  class="el-icon-refresh-left"></i></el-link>
              <div v-else></div>
              <el-link @click="to(index)">{{ $t('去练习') }}<i class="el-icon-arrow-right"></i></el-link>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>


    <div v-if="$store.state.mode == 'CCL'" class="flex margin-b">

      <el-button @click="setType('source')" round type="primary" icon="el-icon-document"
        :plain="type != 'source'">题目</el-button>

      <el-button class="margin-l" @click="setType('segment')" round type="primary" icon="el-icon-folder-opened"
        :plain="type != 'segment'">片段</el-button>
    </div>





    <template v-if="type == 'source'">
      <el-card v-if="$store.state.mode == 'CCL'">
        <h3 slot="header">{{ $t('CCL收藏') }}</h3>
        <el-row :gutter="40">

          <el-col :span="8" :class="{ 'margin-lt': index > 3 }" v-for="index in 5" :key="index">
            <el-card>
              <h3 class="lt pdtb flex flex-between">
                <div><i v-for="index1 in index" style="color:rgb(247, 186, 42)" :key="index1"
                    class="el-icon-star-on"></i>
                </div>
                <div>（{{ (info["ccl_" + index] || 0) }}）</div>
              </h3>
              <div class="flex flex-between margin-t flex-y-center">
                <el-link v-if="info['ccl_' + index]" type="primary" @click="reset(index)">{{ $t('重置') }}<i
                    class="el-icon-refresh-left"></i></el-link>
                <div v-else></div>
                <el-link @click="to1(index)">{{ $t('去练习') }}<i class="el-icon-arrow-right"></i></el-link>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-card>



      <el-card class="margin-lt">
        <h3 slot="header">{{ $t('自定义收藏夹') }}</h3>
        <el-row :gutter="40">

          <el-col :span="8" :class="{ 'margin-lt': index > 2 }" v-for="(item, index) in favorites" :key="index">
            <el-card>
              <h3 class="lt pdtb flex flex-between flex-v-center">
                <div>{{ item.title }}</div>

                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="pointer"> <a @click="add(item)" class="color-white ul-hover ">{{ $t('重命名') }}</a></div>
                    <div class="margin-t pointer"> <a class="color-white ul-hover" @click="remove(item)">{{ $t('删 除')
                    }}</a>
                    </div>
                  </div>
                  <i class="el-icon-more pointer" style="font-size:30px;color:gray"></i>
                </el-tooltip>
              </h3>
              <div class="flex flex-between margin-t flex-v-center">
                <div class="st">{{ $t('共') + $num(item.sources_count) + $t('题') }}</div>
                <el-link v-if="item.sources_count" type="primary" @click="resetFavorite(item.id)">{{ $t('重置') }}<i
                    class="el-icon-refresh-left"></i></el-link>
                <div v-else></div>
                <el-link v-if="item.sources_count" @click="toFavorites(item.id)">{{ $t('去练习') }}<i
                    class="el-icon-arrow-right"></i></el-link>
              </div>
            </el-card>
          </el-col>

          <el-col :span="8" :class="{ 'margin-lt': favorites.length > 2 }">
            <el-card class="pointer">
              <div class="flex flex-h-center padding" @click="add">
                <i class="el-icon-plus" style="font-size:48px;color:#ccc;"></i>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-card>
    </template>

    <div v-else>
      <div class="line"></div>
      <el-empty v-if="segments.length == 0" :description="`${$t('还没有收藏数据')}！`"></el-empty>
      <div class="pointer" v-for="(item, index) in segments" :key="index">
        <div class="flex flex-between padding-s">
          <div class="flex flex-v-center bold">

            <div>{{ index + 1 }}</div>
            <div class="margin-l">{{ item.source.title }}</div>

            <div class="flex">
              <el-tag type="primary" effect="dark" size="small" class="margin-ls">{{ item.source.tag }}</el-tag>
              <el-tag type="primary" effect="dark" size="small" class="margin-ls">#{{ item.source.no }}</el-tag>
              <el-tag effect="dark" size="small" v-if="item.source.frequency == 1" class="margin-ls" type="primary">{{
                $t('高频') }}</el-tag>
              <el-tag effect="dark" size="small" v-if="item.source.is_gmat" class="margin-ls" type="primary">{{ $t('机经')
                }}</el-tag>
              <el-tag effect="dark" size="small" v-if="item.source.is_new" class="margin-ls" type="primary">{{ $t('新题')
                }}</el-tag>
            </div>
          </div>

          <div class="flex flex-v-center">
            <el-tag v-if="item.records_count" type="success" class="margin-l">{{ $t('已练') }}{{ item.records_count
              }}{{ $t('次') }}</el-tag>
            <el-tag v-else type="success" class="margin-l">{{ $t('未练习') }}</el-tag>



          </div>
        </div>


        <div v-for="(segment, index1) in item.segments" :key="segment">
          <div class="hover-btn padding-s flex fex-between flex-v-center" @click="go(segment, item.source)">
            <div class="flex1">
              <div class="bold flex flex-v-center">{{ $t('片段') + ' ' + (segment + 1) }}: <wave-player class="margin-l"
                  :src="$host + '/api/audio/ccl_' + item.source.no + '_' + segment + '/Origin'"></wave-player></div>
              <div class="margin-t">
                {{ $t('音频原文') + ': ' + item.source.words_en.split("\n")[segment] }}
              </div>

              <div class="margin-t" style="word-wrap: break-word;white-space: inherit;">
                {{ $t('参考译文') + ': ' + item.source.words_zh.split("\n")[segment] }}
              </div>
            </div>

            <div class="margin-l" style="flex-shrink: 0;">
              <i class="el-icon-right" style="font-size: 20px;color: #e6a13c;"></i>
            </div>
          </div>
          <div class="line" v-if="index1 < segments.length - 1"></div>
        </div>
        <div class="padding-s" v-if="item.segments.length > 1">
          <el-button @click="go(item.segments.join(','), item.source)" round type="primary" size="small">{{ $t('一起练习')
            }}<i class="el-icon-right"></i></el-button>
        </div>
      </div>

    </div>
    <div class="center margin-t">
      <el-pagination @current-change="pageChange" background layout="prev, pager, next, jumper" :total="segment_total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import WavePlayer from '../../components/WavePlayer.vue';
export default {
  name: "favorites",
  components: {
    WavePlayer,
  },
  data() {
    return {
      type: 'source',
      date: "",
      tableData: [{}, {}],
      tab: 0,
      info: {},
      favorites: [],
      segments: [],
      page: 1,
      segment_total: 0,
    };
  },

  created() {
    // this.query();
    // this.query_favorites()
  },

  activated() {
    if (this.$store.state.mode == "CCL") {
      this.query_segments();
    }
    this.query();
    this.query_favorites()
  },

  methods: {
    go(segment, source) {
      this.$router.push({ path: '/main/ccl', query: { no: source.no, segment: segment, tag: source.tag } })
    },
    pageChange(page) {
      this.query_segments(page);
    },

    query_segments(page) {
      if (page) this.page = page;
      this.$http.post("/api/ccl/favorite/list", { page: this.page }).then((res) => {
        this.segment_total = res.total;
        this.segments = res.data;
      })
    },

    setType(type) {
      this.type = type;
      if (this.type == 'segment' && this.segments.length == 0) {
        this.query_segments();
      }
    },




    goBack() {
      this.$router.back();
    },
    query_favorites() {
      this.$http.post("/api/source/mine/favorite/list").then((favorites) => {
        this.favorites = favorites;
      })
    },
    remove(item) {
      this.$confirm('', this.$t('确认删除此收藏夹') + '?', {
        showCancle: false,
        center: true,
        confirmButtonClass: "confirm-btn",
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'primary'
      }).then(() => {
        this.$http.post("/api/source/mine/favorite/remove", { id: item.id }).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('删除成功') + '!'
          });
          this.query_favorites();
        })
      }).catch(() => {

      });
    },

    add(item) {
      if (this.$store.getters.getRole() > 0) {
        this.$prompt('', this.$t('创建收藏夹'), {
          inputValue: item ? item.title : '',
          center: true,
          roundButton: true,
          confirmButtonText: this.$t('确定'),
          cancelButtonText: this.$t('取消'),
        }).then(({ value }) => {
          if (value) {
            this.$http.post("/api/source/mine/favorite", { id: item ? item.id : 0, title: value }).then(() => {
              this.$message({
                type: 'success',
                message: this.$t("操作成功") + "!"
              });
              this.query_favorites();
            })
          }
        }).catch(() => {

        });
      } else {
        this.$vip_alert("添加单词本");
      }
    },

    toFavorites(id) {
      if (this.$store.state.mode == "CCL") {
        this.$router.push("/main/ccl?tag=favorite" + id);
      } else {
        this.$router.push("/main/pte?tag=favorite" + id);
      }
    },

    to(tag) {
      this.$router.push("/main/pte?tag=star" + tag);
    },

    to1(tag) {
      this.$router.push("/main/ccl?tag=star" + tag);
    },
    query() {
      this.$http.post("/api/source/favorites").then((info) => {
        if (info) {
          this.info = info;
        }
      })
    },

    reset(index) {

      this.$confirm(this.$t('删除后所有记录将会清空,确认删除此收藏记录') + '?', this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        confirmButtonClass: "confirm-btn",
        cancelButtonText: this.$t('取消'),
        type: 'warning'
      }).then(() => {
        this.$http.post("/api/source/favorite/remove", { stars: index }).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('重置成功') + '!'
          });

          this.query()
        })
      }).catch(() => {

      });
    },
    resetFavorite(id) {
      this.$confirm(this.$t('删除后所有记录将会清空,确认删除此收藏记录') + '?', this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        confirmButtonClass: "confirm-btn",
        cancelButtonText: this.$t('取消'),
        type: 'warning'
      }).then(() => {
        this.$http.post("/api/source/mine/favorite/clear", { id: id }).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('重置成功') + '!'
          });

          this.query_favorites()
        })
      }).catch(() => {

      });
    }
  },
};
</script>

<style scoped>
.header {
  padding: 0 28px;
  background-image: linear-gradient(0deg, #1ad0b3, #23ccd1), linear-gradient(#fff, #fff);
  border-radius: 10px;
  color: #fff;
}

.l-img {
  height: 160px;
  width: 120px;
}

.title {
  text-decoration: underline;
  text-underline-offset: 20px;
  text-decoration-color: #1ad0b3;
}

.hover-btn:hover {
  background: rgb(245, 217, 177);
  border-radius: 10px;
}
</style>
